import Layout from "../components/Layout";

const SECTIONS = [
  ["Acceptance of Terms", "By creating an account or using Insurance License Lab, you agree to these terms. This is a general template and not legal advice."],
  ["Study Aid Disclaimer", "Insurance License Lab is an independent exam-preparation study aid. It is not affiliated with, endorsed by, or a substitute for any official state insurance department course or examination. We do not guarantee that you will pass any exam."],
  ["Accounts", "You are responsible for keeping your login credentials secure and for all activity under your account. One account is intended for one individual user."],
  ["Your Membership", "Full Access is a personal membership for your own exam preparation, giving you the workbook, streaming audio, and quiz bank. It's meant for your individual use and isn't transferable to another person."],
  ["Payments & Access", "Full Access is $49.95 per year and renews automatically each year until you cancel. You can cancel anytime from your account and will keep access through the end of the year you've already paid for. Payments are processed securely by our payment provider."],
  ["Refunds", "Because access to digital content is granted immediately, purchases are generally non-refundable. Contact support for billing issues."],
  ["Cancellation & Expiration", "You can cancel auto-renew at any time from your account. If you cancel, access continues until the end of your current paid year and then locks back to the free sample tier; your progress data is retained."],
  ["Changes", "We may update these terms or the content. Continued use after changes constitutes acceptance."],
  ["Contact", "Questions about these terms? Reach us through the Support page."],
];

export default function Terms() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="terms-page">
        <h1 className="font-heading text-3xl font-bold text-[#0A192F]">Terms of Service</h1>
        <p className="text-slate-400 text-sm mt-1">Last updated: {new Date().toLocaleDateString()}</p>
        <div className="mt-8 space-y-8">
          {SECTIONS.map(([h, b]) => (
            <section key={h}>
              <h2 className="font-heading text-lg font-semibold text-[#0A192F]">{h}</h2>
              <p className="text-slate-600 mt-2 leading-relaxed">{b}</p>
            </section>
          ))}
        </div>
      </div>
    </Layout>
  );
}
